import { getToken, setToken, setUserName, setUser, getUser, setRole, removeToken } from '@/utils/auth'
import request from '@/utils/request'
import Vue from "vue"
import { Toast } from 'vant';
Vue.use(Toast);
const state = {
    token: getToken(),
    roles: [],
    name: '',
    avatar: '',
    userId: getUser(),
    roleSlug: '',
    campUser: '',
    orgId: ''
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_USERID: (state, userId) => {
        state.userId = userId
    },
    SET_ROLE_SLUG: (state, roleSlug) => {
        state.roleSlug = roleSlug
    },
    SET_CAMPUSER: (state, campUser) => {
        state.campUser = campUser
    },
    SET_ORGID: (state, orgId) => {
        state.orgId = orgId
    }
}

const actions = {
    login({ commit }, userInfo) {
        const { username, password, verifyCode } = userInfo
        return new Promise((resolve, reject) => {
            request({
                url: '/api/login',
                method: 'post',
                data: {
                    username,
                    password,
                    verifyCode,
                    type: 4
                },
            }).then(response => {
                setToken(response.data.username);//登录成功后将token存储在cookie之中
                setUser(response.data.userId);//登录成功后将token存储在cookie之中
                setUserName(response.data.name)
                setRole(response.data.role.slug);//角色标识
                commit('SET_TOKEN', response.data.username)
                commit('SET_NAME', response.data.username)
                commit('SET_USERID', response.data.userId)
                commit('SET_ROLE_SLUG', response.data.role.slug)
                resolve();
            }).catch(error => {
                reject(error)
            });
        });
    },
    getInfo({ commit }) {
        return new Promise((resolve, reject) => {
            // 请求
            request({
                url: '/api/user/get_user',
                method: 'get',
                params: { id: getUser() }
            }).then(response => {
                console.log(response.data)
                commit('SET_CAMPUSER', response.data.campUser)
                localStorage.setItem('campUser', JSON.stringify(response.data.campUser))
                commit('SET_ROLES', response.data.roles[0])
                commit('SET_ORGID', response.data.orgId)
                commit('SET_AVATAR', response.data.avatar)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    resetToken({ commit }) {
        return new Promise(resolve => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
